import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Image from '../../ContentfulImage';
import Placeholder from '../../Placeholder';

const Wrapper = styled.div``;

const Results = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 20px;
  max-height: 50vh;
  overflow-y: scroll;
  overscroll-behavior-y: contain;
  padding-right: 10px;
  width: 100%;
`;

const Result = styled.div`
  background-color: #f2f2f2;
  flex-shrink: 0;
  margin: 10px 0;
  width: calc((100% - 70px) / 4);
`;

const ResultInner = styled.div`
  height: 100%;
  padding: 20px;
  width: 100%;
`;

const ImageContainer = styled.div`
  background-color: white;
  width: 100%;
`;

const ItemName = styled.div`
  font-family: FuturaStd;
  font-size: 18px;
  line-height: 1.11;
  margin-top: 20px;
  text-align: center;
  color: #282828;
`;

const Button = styled.div`
  color: white;
  cursor: pointer;
  background-color: black;
  margin: 20px auto;
  padding: 20px;
  text-align: center;
  width: 200px;
`;

const NoResults = styled.div`
  align-items: center;
  display: flex;
  height: 200px;
  justify-content: center;
  width: 100%;
`;

const contentTypeToUrl = {
  product: 'product',
  productRangeHairCare: 'range/hair-care',
  productRangeHairColor: 'range/hair-color',
  productRangeMakeUp: 'range/make-up',
  productRangeMens: 'range/mens',
  productRangePerm: 'range/perm',
  productRangeSkinBodyCare: 'range/skin-body-care',
  productRangeStyling: 'range/styling',
};

class SearchResult extends React.Component {
  static defaultProps = {
    copy: {},
  };

  static propTypes = {
    copy: PropTypes.shape(),
    data: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    locale: PropTypes.string.isRequired,
  };

  state = {
    showing: 4,
  };

  handleClick = () => {
    this.setState(state => ({ showing: state.showing + 4 }));
  };

  render() {
    const { showing } = this.state;
    const { copy, data, locale } = this.props;

    return (
      <Wrapper>
        {data.length > 0 ? (
          <Results>
            {data.slice(0, showing).map(item => (
              <Result key={item.name}>
                <Link
                  to={`/${locale}/${contentTypeToUrl[item.contentType]}/${item.slug}`}
                  href={`/${locale}/${contentTypeToUrl[item.contentType]}/${item.slug}`}
                >
                  <ResultInner>
                    {item.contentType === 'product' &&
                      (item.image ? (
                        <ImageContainer>
                          <Image
                            src={item.image}
                            options={{ w: '100%', aspectRatio: 1, objectFit: 'contain', size: 265 }}
                          />
                        </ImageContainer>
                      ) : (
                        <Placeholder w="100%" pb="100%" />
                      ))}
                    {item.contentType !== 'product' &&
                      (item.image ? (
                        <ImageContainer>
                          <Image
                            src={item.image}
                            options={{ w: '100%', aspectRatio: 1, objectFit: 'contain', size: 265 }}
                          />
                        </ImageContainer>
                      ) : (
                        <Placeholder w="100%" pb="100%" />
                      ))}
                    <ItemName>{item.name}</ItemName>
                  </ResultInner>
                </Link>
              </Result>
            ))}
            <div style={{ width: 'calc((100% - 60px) / 4)' }} />
            <div style={{ width: 'calc((100% - 60px) / 4)' }} />
            <div style={{ width: 'calc((100% - 60px) / 4)' }} />
          </Results>
        ) : (
          <NoResults>{copy.no_results}</NoResults>
        )}
        {data.length > showing && <Button onClick={this.handleClick}>Show More</Button>}
      </Wrapper>
    );
  }
}

const mapState = state => ({
  copy: state.siteOptions.siteCopyGeneral,
  locale: state.locale,
});

export default connect(mapState)(SearchResult);



// WEBPACK FOOTER //
// ./src/components/GlobalMenu/Desktop/SearchResult.js